"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .controller(
    "signupCtrl",
    function (
      $rootScope,
      $state,
      $stateParams,
      User,
      MessageService
    ) {
      var vm = this;

      vm.projectModule = config.projectModule;
      vm.model = {};

      switch (vm.projectModule) {
        case "Colors":
          $("body").addClass("a-sua-cor");
          $(".auth-img").prepend(
            '<img src="/images/logo-sw-colorsnap.png" alt="A Sua Cor" />'
          );
          $(".powered-img").prepend(
            '<img src="/Images/img-asuacor-powered.svg" alt="Powered by Astéria" />'
          );
          break;

        default:
          $state.go("login");
      }

      if ($stateParams.token) {
        User.inviteValidate(
          {
            authCodeGuid: $stateParams.token,
          },
          function (response) {
            vm.tokenEmail = Object.values(response).slice(0, -2).join("");
            vm.model.email = vm.tokenEmail || '';
          },
          function (response) {
            $state.go("signup");
          }
        );
      }


      $rootScope.laddaLoading = false;

      vm.step = 1;
      vm.acceptedTerms = false;

      vm.nextStep = function () {
        vm.step++;
      };

      vm.submit = function () {
        vm.auth_error = null;

        $rootScope.laddaLoading = true;

        if (vm.model.password !== vm.model.confirmPassword) {
          vm.auth_error = "As senhas não coincidem.";
          $rootScope.laddaLoading = false;
          return;
        }

        User.inviteSignup(
          {
            name: vm.model.name,
            email: vm.model.email,
            password: vm.model.password,
            cnpjCpf: vm.model.cnpjCpf
          },
          function (response) {
            $rootScope.laddaLoading = false;
            vm.step = 3;
          },
          function (response) {
            $rootScope.laddaLoading = false;
            MessageService.alertError(response.data);
          }
        );
      }
    }
  );
